export const InstitutionIcon = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="institution-icon">
    <defs>
      <linearGradient id="buildingGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#f3f4f6', stopOpacity: 1 }} />
      </linearGradient>
      <linearGradient id="columnGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" style={{ stopColor: '#e5e7eb', stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#e5e7eb', stopOpacity: 1 }} />
      </linearGradient>
      <linearGradient id="roofGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#f9fafb', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#e5e7eb', stopOpacity: 1 }} />
      </linearGradient>
      <filter id="buildingShadow">
        <feGaussianBlur stdDeviation="2" result="coloredBlur" />
        <feOffset dx="0" dy="3" result="offsetBlur" />
        <feMerge>
          <feMergeNode in="offsetBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    {/* Base/Foundation */}
    <rect x="15" y="70" width="70" height="8" fill="#d1d5db" className="building-base" />
    <rect x="12" y="78" width="76" height="4" fill="#9ca3af" className="building-foundation" />

    {/* Main Building Body */}
    <rect
      x="20"
      y="35"
      width="60"
      height="35"
      fill="url(#buildingGradient)"
      stroke="#d1d5db"
      strokeWidth="0.5"
      className="building-body"
      filter="url(#buildingShadow)"
    />

    {/* Classical Columns */}
    <g className="columns">
      {/* Column 1 */}
      <rect
        x="25"
        y="38"
        width="6"
        height="32"
        fill="url(#columnGradient)"
        stroke="#d1d5db"
        strokeWidth="0.3"
        className="column column-1"
      />
      <rect x="25" y="38" width="6" height="2" fill="#e5e7eb" className="column-capital" />
      <rect x="25" y="68" width="6" height="2" fill="#d1d5db" className="column-base" />

      {/* Column 2 */}
      <rect
        x="38"
        y="38"
        width="6"
        height="32"
        fill="url(#columnGradient)"
        stroke="#d1d5db"
        strokeWidth="0.3"
        className="column column-2"
      />
      <rect x="38" y="38" width="6" height="2" fill="#e5e7eb" className="column-capital" />
      <rect x="38" y="68" width="6" height="2" fill="#d1d5db" className="column-base" />

      {/* Column 3 */}
      <rect
        x="51"
        y="38"
        width="6"
        height="32"
        fill="url(#columnGradient)"
        stroke="#d1d5db"
        strokeWidth="0.3"
        className="column column-3"
      />
      <rect x="51" y="38" width="6" height="2" fill="#e5e7eb" className="column-capital" />
      <rect x="51" y="68" width="6" height="2" fill="#d1d5db" className="column-base" />

      {/* Column 4 */}
      <rect
        x="64"
        y="38"
        width="6"
        height="32"
        fill="url(#columnGradient)"
        stroke="#d1d5db"
        strokeWidth="0.3"
        className="column column-4"
      />
      <rect x="64" y="38" width="6" height="2" fill="#e5e7eb" className="column-capital" />
      <rect x="64" y="68" width="6" height="2" fill="#d1d5db" className="column-base" />
    </g>

    {/* Pediment (triangular roof) */}
    <path
      d="M 15 35 L 50 15 L 85 35 Z"
      fill="url(#roofGradient)"
      stroke="#d1d5db"
      strokeWidth="0.5"
      className="pediment"
      filter="url(#buildingShadow)"
    />

    {/* Pediment detail lines */}
    <path
      d="M 20 33 L 50 18 L 80 33"
      stroke="#9ca3af"
      strokeWidth="1"
      fill="none"
      className="pediment-detail"
      opacity="0.6"
    />

    {/* Central entrance/door */}
    <g className="entrance">
      <rect
        x="42"
        y="55"
        width="16"
        height="15"
        fill="#374151"
        stroke="#6b7280"
        strokeWidth="0.5"
        className="door"
      />
      <rect x="42" y="53" width="16" height="2" fill="#d1d5db" className="door-arch" />
      <circle cx="54" cy="62" r="1" fill="#fbbf24" className="door-knob" />
    </g>

    {/* Windows */}
    <g className="windows">
      {/* Top row windows */}
      <rect
        x="28"
        y="42"
        width="5"
        height="6"
        fill="#374151"
        stroke="#6b7280"
        strokeWidth="0.3"
        opacity="0.8"
        className="window window-1"
      />
      <rect
        x="46"
        y="42"
        width="5"
        height="6"
        fill="#374151"
        stroke="#6b7280"
        strokeWidth="0.3"
        opacity="0.8"
        className="window window-2"
      />
      <rect
        x="64"
        y="42"
        width="5"
        height="6"
        fill="#374151"
        stroke="#6b7280"
        strokeWidth="0.3"
        opacity="0.8"
        className="window window-3"
      />

      {/* Window glows */}
      <rect
        x="28.5"
        y="42.5"
        width="4"
        height="5"
        fill="#fbbf24"
        opacity="0.3"
        className="window-glow glow-1"
      />
      <rect
        x="46.5"
        y="42.5"
        width="4"
        height="5"
        fill="#fbbf24"
        opacity="0.3"
        className="window-glow glow-2"
      />
      <rect
        x="64.5"
        y="42.5"
        width="4"
        height="5"
        fill="#fbbf24"
        opacity="0.3"
        className="window-glow glow-3"
      />
    </g>

    {/* Institution emblem/seal at top of pediment */}
    <g className="emblem">
      <circle cx="50" cy="25" r="6" fill="#6366f1" className="emblem-circle" />
      <circle
        cx="50"
        cy="25"
        r="4.5"
        fill="none"
        stroke="#fbbf24"
        strokeWidth="0.8"
        className="emblem-ring"
      />
      <text
        x="50"
        y="28"
        textAnchor="middle"
        fill="#ffffff"
        fontSize="6"
        fontWeight="bold"
        className="emblem-text"
      >
        IIT
      </text>
    </g>

    {/* Decorative stars for academic excellence */}
    <g className="excellence-stars">
      <path
        d="M 10 20 L 11 22 L 13 22 L 11.5 23.5 L 12 25.5 L 10 24 L 8 25.5 L 8.5 23.5 L 7 22 L 9 22 Z"
        fill="#fbbf24"
        className="excellence-star star-left"
        opacity="0.8"
      />
      <path
        d="M 90 20 L 91 22 L 93 22 L 91.5 23.5 L 92 25.5 L 90 24 L 88 25.5 L 88.5 23.5 L 87 22 L 89 22 Z"
        fill="#fbbf24"
        className="excellence-star star-right"
        opacity="0.8"
      />
    </g>

    {/* Knowledge beam/light from top */}
    <g className="knowledge-beam">
      <path d="M 50 15 L 45 5 L 55 5 Z" fill="#fbbf24" opacity="0.4" className="beam" />
      <circle cx="50" cy="5" r="2" fill="#fbbf24" className="beam-light" />
    </g>
  </svg>
)

